module.exports = __webpack_public_path__ + "img/smoke9.d0970ae6.png";